export default (function (b64, descriptor) {
  var newlined = (b64.match(/.{1,64}/g) || []).join('\n');
  return "-----BEGIN ".concat(descriptor, "-----\n").concat(newlined, "\n-----END ").concat(descriptor, "-----");
});